/** Textes « taches » — le français fait foi. */
export const taches = {
  bonjour: (nom: string) => `bonjour ${nom}`,
  miseEnService: (faites: number, total: number) => `Mise en service — ${faites} sur ${total}`,
  demandesRefusees: (n: number) => `${n} demande(s) refusée(s) faute de véhicule sur 30 jours — environ `,
  enRetard: (n: number) => `${n} véhicule(s) en retard`,
  fileDuJour: (departs: number, retours: number) => `File du jour — ${departs} départ(s), ${retours} retour(s)`,
  champ: (entite: string, champ: string) => `${entite} — champ « ${champ} »`,
  demandeLe: (motif: string, date: string) => `${motif} · demande le ${date}`,
  aFaireMaintenant: 'À faire maintenant',
  aujourdHui: "Aujourd'hui",
  localeDate: 'fr-FR',
  mesVoitures: 'Mes voitures',
  voituresLibres: 'Voitures libres',
  nouvelleLocation: 'Nouvelle location',
  voirListe: 'Voir la liste',
  reduire: 'Réduire',
  mesIntro: "Ce qui reste à renseigner pour que les chiffres du logiciel soient justes. Cette carte disparaîtra d'elle-même.",
  indispensable: 'Indispensable',
  yAller: 'Y aller',
  tresoDisponible: 'Trésorerie réellement disponible',
  soldeCaisse: 'Solde de caisse ',
  moinsPrestations: '− prestations futures déjà encaissées ',
  moinsCautions: '− cautions détenues ',
  voirDetail: 'Voir le détail',
  tauxUtilisation: "Taux d'utilisation",
  tauxDetail: 'cible 75–85 % · voir mes voitures',
  revenuParVoiture: 'Revenu par voiture / jour',
  revenuDetail: 'voir le détail par voiture',
  prixMoyen: 'Prix moyen journalier',
  prixDetail: 'réellement pratiqué',
  caMois: "Chiffre d'affaires du mois",
  caDetail: 'voir la prévision',
  diagnostic: 'Diagnostic',
  argentInvisible: "L'argent que vous ne voyez pas",
  caPerdu: " de chiffre d'affaires perdu.",
  signalezLes: 'Signalez-les au responsable, ne tranchez pas seule.',
  enPriorite: 'À traiter en priorité.',
  toutAJour: 'Tout est a jour',
  aucunDepart: "Aucun départ ni retour à traiter pour l'instant.",
  signaler: 'Signaler au responsable',
  faireDepart: 'Faire le départ',
  faireRetour: 'Faire le retour',
  attenteResponsable: 'En attente du responsable',
  traiter: 'Traiter',
  soldesAEncaisser: 'Soldes à encaisser',
  thContrat: 'Contrat',
  thClient: 'Client',
  thSoldeDu: 'Solde dû',
  encaisser: 'Encaisser',
  aSurveiller: 'À surveiller',
  pasAVous: "Ce qui n'est pas a vous",
  pasAVousTexte: "Ces montants sont en caisse mais ne sont pas disponibles : ils correspondent a des prestations que vous n'avez pas encore livrees, ou a de l'argent qui appartient a vos clients.",
  prestationsFutures: 'Prestations futures déjà encaissées',
  thLocation: 'Location',
  thPeriode: 'Période',
  thNonLivre: 'Non livré',
  cautionsDetenues: 'Cautions détenues',
  cautionsTexte: " — c'est l'argent de vos clients, il devra leur être rendu.",
};
